import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { BeverageService } from 'app/services/dal/beverage.service';
import { ToastService } from 'app/services/toast.service';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import * as Action from './actions'
import { Router } from '@angular/router';
import { shouldLoadData, trackLoading } from '../effect-helpers';
import * as fromBeverage from './reducer';



@Injectable()
export class BeverageEffects {

  constructor(
    private router: Router,
    private actions$: Actions,
    private store: Store,
    private beverageService: BeverageService,
    private toastService: ToastService
  ) { }

  getBeverages$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadItems),
        shouldLoadData(
          this.store,
          'beverages',
          (action) => action.barId,
          fromBeverage.selectAllItems
        ),
        switchMap((action) =>
          trackLoading(
            this.store,
            'beverages',
            action.barId,
            this.beverageService.getItems(action.barId).pipe(
              map(beverages => Action.loadItemsSuccess({ items: beverages })),
              catchError(error => of(Action.loadItemsFailure({ error })))
            )
          )
        )
      );
  });


  setItemAndNavigate$ = createEffect(
    () => {
      return this.actions$
        .pipe(
          ofType(Action.setItemAndNavigate),
          tap(({ id }) => {
            if (!id) {
              this.router.navigate(['/inventory/beer/new']);
              return;
            }
            this.router.navigate(['/inventory/beer/details', id]);
          }),
        )
    },
    { dispatch: false }
  );



  addBeverage$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.addItem),
        mergeMap((action) => from(this.beverageService.create(action.item, action.id))
          .pipe(
            map(() => Action.addItemSuccess({ id: action.id })),
            catchError(error => of(Action.addItemFailure({ error })))
          )
        )
      );
  });




  updateBeverage$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.updateBeverage),
        mergeMap((action) => from(this.beverageService.updateItem(action.beverage))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return Action.updateBeverageSuccess();
            }),
            catchError(error => of(Action.updateBeverageFailure({ error })))
          )
        )
      );
  });

  softUpdate$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.softUpdate),
        mergeMap((action) => from(this.beverageService.softUpdate(action.id, action.data, action.uid))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return Action.softUpdateSuccess({ id: action.id, data: action.data });
            }),
            catchError(error => of(Action.softUpdateFailure({ error })))
          )
        )
      );
  });

  delete$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.deleteItem),
        mergeMap((action) => from(this.beverageService.delete(action.id))
          .pipe(
            map(() => {
              return Action.deleteItemSuccess();
            }),
            catchError(error => of(Action.deleteItemFailure({ error })))
          )
        )
      );
  });

  deleteSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.deleteItemSuccess),
        tap(() => {
          this.toastService.deleteItemSuccess();
          this.router.navigateByUrl("/inventory/beer");
        }),
      );
  }, { dispatch: false });


  // getBeveragesSorted$ = createEffect(() => {
  //   return this.actions$
  //       .pipe(
  //           ofType(BeverageActions.loadItemsSorted),
  //           mergeMap((action) => this.beverageService.getItemsOrderBy(action.barId, action.sortOrder)
  //             .pipe(
  //               map(beverages => BeverageActions.loadItemsSuccess({ items: beverages })),
  //               catchError(error => of(BeverageActions.loadItemsFailure({ error })))
  //             )
  //           )
  //         );
  // });


}
